import cn from 'clsx';
import React, { ReactNode } from 'react';

import { QuestionTooltip } from 'components/QuestionTooltip';
import { MetricKeys, events } from 'constants/metrics';
import { staticTabsId } from 'constants/ui';
import { tabIds } from 'store/UIStore/UIStore';
import { TooltipPositionType } from 'types/Tooltip';
import { sendDataLakeEvent, sendMetricsEvent } from 'utils/metrics';
import { scrollTo } from 'utils/nativeDOM';

import { TabType } from './types';

import css from './Tab.module.css';

interface TabProps {
  className?: string;
  tab: TabType;
  isActive: boolean;
  children: ReactNode;
  onChange: Function;
  tooltipPosition?: TooltipPositionType;
  isSpecial?: boolean;
  isSticky?: boolean;
}

const Tab = (props: TabProps) => {
  const { tab, className, isActive, children, onChange, tooltipPosition = 'top', isSpecial, isSticky } = props;

  const handleClick = (event: React.MouseEvent) => {
    if (tab.disabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    if (tab.href) return;

    onChange(tab.id);

    if (isSticky) scrollTo(`#${staticTabsId}`, { block: 'start' });

    if (!isActive && tab.id === tabIds.savedFilters) {
      sendMetricsEvent(events.clickFilterTab);
    }

    if (!isActive) {
      const target = `${tab.id}Open` as MetricKeys;

      if (events[target]) {
        sendDataLakeEvent(events[target]);
      }
    }
  };

  return (
    <a
      className={cn(css.tab, className, {
        [css.tab_active]: isActive,
        [css.tab_disabled]: tab.disabled,
        [css.tab_special]: !tab.disabled && isSpecial,
        'glz-tooltip': tab.disabled,
        [`glz-is-position-${tooltipPosition}`]: tab.disabled,
      })}
      href={tab.href}
      role="button"
      onClick={handleClick}
    >
      {children}
      {tab.disabled && tab.tooltip && (
        <span className="glz-tooltiptext" style={{ width: 250, whiteSpace: 'normal' }}>
          {tab.tooltip}
        </span>
      )}

      {!tab.disabled && tab.hintTooltip && <QuestionTooltip size={16} text={tab.hintTooltip} />}
    </a>
  );
};

export { Tab };
